import { render, staticRenderFns } from "./CreateEditRatecard.vue?vue&type=template&id=4cc86af2&"
import script from "./CreateEditRatecard.vue?vue&type=script&lang=js&"
export * from "./CreateEditRatecard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports